export { LyCheckboxModule, LyCheckboxService, LY_CHECKBOX_CONTROL_VALUE_ACCESSOR, CheckboxState, LyCheckbox } from './ly-checkbox.module';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/checkbox/index.js
// module id = 1367
// module chunks = 31